import { desktopAppVersion, desktopPlatform, isDesktopApp } from './desktopApp'

// Mirrored in backend/src/clientAnalytics.ts; its contract test pins both sides.
export const SURFACE_PROPERTY = 'app_shell'
export const SURFACE_DESKTOP = 'desktop'
export const SURFACE_WEB = 'web'

export function clientAnalyticsProperties() {
  return {
    [SURFACE_PROPERTY]: isDesktopApp() ? SURFACE_DESKTOP : SURFACE_WEB,
    desktop_platform: desktopPlatform() ?? undefined,
    desktop_version: desktopAppVersion() ?? undefined,
  }
}
